import { Routes, Route } from "react-router-dom";
import "./Styles/Global.css";
import Home from "./Components/Home";
import Header from "./Components/Header";
import MobileBottomNav from "./Components/MobileBottomNav";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      {/* <MobileBottomNav /> */}
    </>
  );
}

export default App;
